<template>
  <div class="visitor-source-label">
    <template v-if="platform === 'web'">
      <i class="iconfont">&#xe6f5;</i>
    </template>

    <template v-if="platform === 'wechat'">
      <i class="iconfont">&#xe600;</i>
    </template>

    <template v-if="platform === 'weibo'">
      <i class="iconfont">&#xe62f;</i>
    </template>

    <template v-if="platform === 'douyin'">
      <i class="iconfont">&#xe607;</i>
    </template>

    <template v-if="platform === 'redbook'">
      <i class="iconfont">&#xe7eb;</i>
    </template>

    <template v-if="platform === 'kuaishou'">
      <i class="iconfont">&#xe66f;</i>
    </template>

    <span class="source-text">
      {{ sourceText }}
    </span>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { mapState } from "vuex";
import { DefaultSourceMap } from "@/data/source";

export default defineComponent({
  name: "VisitorSourceLabel",
  props: {
    visitor: Object,
  },
  computed: {
    ...mapState({
      wechatApps: (state) => state.common.wechatAppsObj,
      weiboApps: (state) => state.common.weiboAppsObj,
      douyinApps: (state) => state.common.douyinAppsObj,
      kuaishouApps: (state) => state.common.kuaishouAppsObj,
      redbookApps: (state) => state.common.redbookAppsObj,
    }),
    platform() {
      return this.visitor?.platform || "";
    },
    sourceText() {
      if (!this.visitor) return "";
      let displayText = "";
      switch (this.visitor.platform) {
        case "web":
          return this.getWebSourceText();
        case "wechat":
          return this.getWechatSourceText();
        case "weibo":
          return this.weiboApps[this.visitor.appid]?.name;
        case "douyin":
          displayText = this.douyinApps[this.visitor.appid]?.name || '已解绑';
          if (this.visitor.subscribe_ad?.campaign_name) {
            displayText +=
              " - 广告计划: " + this.visitor.subscribe_ad.campaign_name;
          }
          return displayText;
        case "kuaishou":
          return this.getKuaishouSourceText();
        case "redbook":
          displayText = this.redbookApps[this.visitor.appid]?.name;

          if (this.visitor.subscribe_ad?.campaign_name) {
            displayText +=
              " - 广告计划: " + this.visitor.subscribe_ad.campaign_name;
          }
          return displayText;
        default:
          return "";
      }
    },
  },

  methods: {
    getWebSourceText() {
      const source = this.visitor.source;
      let displayText = "";

      if (source === "search") {
        displayText = DefaultSourceMap[this.visitor.engine];
      } else if (source === "custom") {
        displayText = `自定义(${this.visitor.custom_source})`;
      } else {
        displayText = DefaultSourceMap[source];
      }

      if (this.visitor.keyword) {
        displayText += `(${this.visitor.keyword})`;
      }

      return displayText;
    },

    getWechatSourceText() {
      const wechatApp = this.wechatApps[this.visitor.appid] || this.visitor.app;

      let displayText = "";

      if (wechatApp?.corp_name) {
        displayText = `${wechatApp.name} @${wechatApp.corp_name}`;
      } else {
        displayText = wechatApp?.name;
      }

      if (this.visitor.subscribe_from) {
        let subscribeText = `${this.visitor.subscribe_from}`;

        if (this.visitor.subscribe_ad) {
          if (this.visitor.subscribe_ad.campaign_name) {
            subscribeText += ` - 广告计划: ${this.visitor.subscribe_ad.campaign_name}`;
          } else if (this.visitor.subscribe_ad.adgroup_name) {
            subscribeText += ` - 广告: ${this.visitor.subscribe_ad?.adgroup_name}`;
          } else if (this.visitor.subscribe_ad.campaign_id) {
            subscribeText += ` - 广告计划: ${this.visitor.subscribe_ad.campaign_id}`;
          } else if (this.visitor.subscribe_ad.adgroup_id) {
            subscribeText += ` - 广告: ${this.visitor.subscribe_ad.adgroup_id}`;
          }

          if (
            this.platform === "redbook" &&
            !this.visitor.subscribe_ad?.campaign_name &&
            this.visitor.subscribe_ad?.note_info
          ) {
            subscribeText += ` - 笔记: ${this.visitor.subscribe_ad?.note_info.title}`;
          }
        }

        if (this.visitor.qrcode_name) {
          subscribeText += `-${this.visitor.qrcode_name}`;
        }

        displayText += `-${subscribeText}`;
      }

      return displayText;
    },

    getKuaishouSourceText() {
      let displayText = this.kuaishouApps[this.visitor.appid]?.name || "已解绑";

      let suffix = "";
      if (this.visitor.subscribe_scene === "ad") {
        suffix = "-广告";
      } else if (this.visitor.subscribe_scene === "normal") {
        suffix = "-自然流量";
      } else if (this.visitor.subscribe_scene === "unknown") {
        suffix = "-未知";
      }

      if (this.visitor.subscribe_ad?.campaign_name) {
        suffix += "-广告计划: " + this.visitor.subscribe_ad.campaign_name;
      }

      return displayText + suffix;
    },
  },
});
</script>

<style lang="less" scoped>
.visitor-source-label {
  display: flex;
  align-items: center;
  min-width: 0;
  line-height: 18px;
  font-size: 13px;

  .iconfont {
    flex-shrink: 0;
    margin-right: 4px;
    font-size: 14px;
  }

  .source-text {
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
